<template>
  <div class="box" :class="{airportView: airportInfo !== null}">
    <div class="scheduleItem" @click="onClickSchedule">
      <div class="cell flight">
        <div class="no">{{item.flightNo}}</div>
        <img :src="item.flightLogo" :alt="item.flightName" />
        <div class="name">{{item.flightName}}</div>
      </div>
      <div class="cell departure">
        <!-- <div class="airport"><span class="location">{{item.originCity}}</span><button type="button" class="airportName" @click="onClickAirport(item.origin)">{{item.origin}}</button></div> -->
        <div class="airport"><span class="location">{{item.originCity}}</span>({{item.origin}})</div>
        <div class="time">{{item.departuretHour}}</div>
      </div>
      <div class="cell arrival">
        <!-- <div class="airport"><span class="location">{{item.destinationCity}}</span><button type="button" class="airportName" @click="onClickAirport(item.destination)">{{item.destination}}</button></div> -->
        <div class="airport"><span class="location">{{item.destinationCity}}</span>({{item.destination}})</div>
        <div class="time">{{item.arrivalHour}}</div>
      </div>
    </div>
    <div class="detailBox"
      v-if="airportInfo !== null">
      <div class="infoBox">
      {{`${item.originCity} (${airportInfo.airport})`}}
      </div>
      <!-- <AirportDetail
        :locale="locale"
        :lang="lang"
        :info="airportInfo" /> -->
    </div>
    <ScheduleDetail
      v-if="detail"
      :locale="locale"
      :lang="lang"
      :info="item"
      @close="closeDetail" />
  </div>
</template>

<script>
import ScheduleDetail from '@/components/FlightInfo/ScheduleDetail.vue'
export default {
  name: 'ScheduleItem',
  props: [
    'locale',
    'lang',
    'item'
  ],
  components: {
    ScheduleDetail
  },
  data () {
    return {
      airportInfo: null,
      detail: false
    }
  },
  methods: {
    onClickSchedule (e) {
      const airport = e.target.className === 'airportName'
      const data = {
        ident: this.item.ident,
        departurets: this.item.departurets
      }
      this.$store.commit('loading', true)
      this.detail = !airport
      this.$store.dispatch('flightinfo/getScheduleDetail', data).then((res) => {
        this.$store.commit('loading', false)
      })
    },
    onClickAirport (airport) {
      this.$store.commit('loading', true)
      this.$store.dispatch('flightinfo/getAirportInfo', airport).then((res) => {
        if (res) {
          this.airportInfo = res
        } else {
          alert(this.locale.alert_flight_load)
        }
        this.$store.commit('loading', false)
      })
    },
    closeAirport () {
      this.airportInfo = null
    },
    closeDetail () {
      this.detail = false
    }
  }
}
</script>

<style lang="scss" scoped>
.airportView {
  .infoBox {
    padding: 0.3em 15px;
    text-align: center;
    font-size: 0.85em;
    border-left: 1px solid $color-lgrey2;
    border-right: 1px solid $color-lgrey2;
    background-color: $bg-default;
  }
  .airportDetail {
    overflow: hidden;
    border: 1px solid $color-lgrey2;
    border-top: none;
    border-bottom-color: $color-dark;
  }
}
@media screen and (min-width: 768px) {

}
</style>
